"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCachedNotificationHashlist = exports.hasNotificationSession = exports.getLoggedStatus = exports.setCachedNotifications = exports.getCachedNotifications = exports.getCookie = exports.decodeURIObject = void 0;
const constants_1 = require("../constants");
const SecureUserStorageRaw = __importStar(require("@gcloud-npm/utils.secure.user-secure-storage"));
const resolveSecureUserStorage = () => {
    var _a, _b;
    return (SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.SecureUserStorage) ||
        ((_a = SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.default) === null || _a === void 0 ? void 0 : _a.SecureUserStorage) ||
        ((_b = SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.default) === null || _b === void 0 ? void 0 : _b.default) ||
        (SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.default) ||
        SecureUserStorageRaw;
};
const SecureUserStorage = resolveSecureUserStorage();
if (typeof SecureUserStorage !== "function") {
    throw new TypeError("SecureUserStorage export is not a constructor. Verify @gcloud-npm/utils.secure.user-secure-storage package format.");
}
const currentEnv = process.env.NEXT_PUBLIC_ENV_NAME;
const secureUserStorage = new SecureUserStorage();
const COOKIE_NAME_LOGGED = "seth-session-logged";
const COOKIE_NAME_SOFT_LOGGED = "seth-session-softlogged";
const NOTIFICATION_CACHE_DB_NAME = "notification-worker-cache";
const NOTIFICATION_CACHE_STORE_NAME = "processing-mark-by-user";
const NOTIFICATION_CACHE_DB_VERSION = 1;
let notificationCacheDbPromise = null;
function decodeURIObject(obj) {
    let res = null;
    try {
        res = JSON.parse(decodeURIObject(obj));
    }
    catch (e) {
        console.log("Failed to decode URI Object");
    }
    return res;
}
exports.decodeURIObject = decodeURIObject;
function getCookie(cname) {
    if (typeof document === "undefined") {
        return "";
    }
    let name = cname + "=";
    let decodedCookie = "";
    try {
        decodedCookie = decodeURIComponent(document.cookie || "");
    }
    catch (error) {
        decodedCookie = document.cookie || "";
    }
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
exports.getCookie = getCookie;
function getNotificationCacheKey(userId) {
    return `route-handler-notifications:${userId || "anonymous"}`;
}
function canUseIndexedDb() {
    return typeof indexedDB !== "undefined";
}
function getNotificationCacheDb() {
    if (!canUseIndexedDb()) {
        return Promise.resolve(null);
    }
    if (notificationCacheDbPromise) {
        return notificationCacheDbPromise;
    }
    notificationCacheDbPromise = new Promise((resolve) => {
        try {
            const request = indexedDB.open(NOTIFICATION_CACHE_DB_NAME, NOTIFICATION_CACHE_DB_VERSION);
            request.onupgradeneeded = () => {
                const db = request.result;
                if (!db.objectStoreNames.contains(NOTIFICATION_CACHE_STORE_NAME)) {
                    db.createObjectStore(NOTIFICATION_CACHE_STORE_NAME, { keyPath: "key" });
                }
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => resolve(null);
        }
        catch (error) {
            resolve(null);
        }
    });
    return notificationCacheDbPromise;
}
function getIndexedNotificationCache(userId) {
    return __awaiter(this, void 0, void 0, function* () {
        const db = yield getNotificationCacheDb();
        if (!db) {
            return null;
        }
        return new Promise((resolve) => {
            try {
                const transaction = db.transaction(NOTIFICATION_CACHE_STORE_NAME, "readonly");
                const request = transaction
                    .objectStore(NOTIFICATION_CACHE_STORE_NAME)
                    .get(getNotificationCacheKey(userId));
                request.onsuccess = () => resolve(request.result || null);
                request.onerror = () => resolve(null);
            }
            catch (error) {
                resolve(null);
            }
        });
    });
}
function setIndexedNotificationCache({ userId, notifications, notificationList, unreadNotifications, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const db = yield getNotificationCacheDb();
        if (!db) {
            return false;
        }
        return new Promise((resolve) => {
            try {
                const transaction = db.transaction(NOTIFICATION_CACHE_STORE_NAME, "readwrite");
                transaction.objectStore(NOTIFICATION_CACHE_STORE_NAME).put({
                    key: getNotificationCacheKey(userId),
                    cacheType: "route-handler-notifications",
                    updatedAt: Date.now(),
                    notifications,
                    notificationList: Array.isArray(notificationList)
                        ? notificationList
                        : [],
                    unreadNotifications: Array.isArray(unreadNotifications)
                        ? unreadNotifications
                        : [],
                });
                transaction.oncomplete = () => resolve(true);
                transaction.onerror = () => resolve(false);
            }
            catch (error) {
                resolve(false);
            }
        });
    });
}
function getLegacyCachedNotifications(userId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const persistedInfo = yield secureUserStorage.getUserStore({ id: userId });
            const legacyNotifications = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.notifications;
            if (!legacyNotifications) {
                return null;
            }
            return {
                notifications: legacyNotifications === null || legacyNotifications === void 0 ? void 0 : legacyNotifications.notifications,
                notificationList: Array.isArray(legacyNotifications === null || legacyNotifications === void 0 ? void 0 : legacyNotifications.notificationList)
                    ? legacyNotifications.notificationList
                    : [],
                unreadNotifications: Array.isArray(legacyNotifications === null || legacyNotifications === void 0 ? void 0 : legacyNotifications.unreadNotifications)
                    ? legacyNotifications.unreadNotifications
                    : [],
            };
        }
        catch (error) {
            return null;
        }
    });
}
function normalizeCacheEntry(entry = {}) {
    return {
        cachedNotifications: entry === null || entry === void 0 ? void 0 : entry.notifications,
        cachedNotificationList: Array.isArray(entry === null || entry === void 0 ? void 0 : entry.notificationList)
            ? entry.notificationList
            : [],
        cachedUnreadNotifications: Array.isArray(entry === null || entry === void 0 ? void 0 : entry.unreadNotifications)
            ? entry.unreadNotifications
            : [],
    };
}
function getCachedNotifications({ userId }) {
    return __awaiter(this, void 0, void 0, function* () {
        const indexedCache = yield getIndexedNotificationCache(userId);
        if (indexedCache) {
            return normalizeCacheEntry(indexedCache);
        }
        const legacyCache = yield getLegacyCachedNotifications(userId);
        if (legacyCache) {
            yield setIndexedNotificationCache({
                userId,
                notifications: legacyCache.notifications,
                notificationList: legacyCache.notificationList,
                unreadNotifications: legacyCache.unreadNotifications,
            });
            return normalizeCacheEntry(legacyCache);
        }
        return normalizeCacheEntry();
    });
}
exports.getCachedNotifications = getCachedNotifications;
function setCachedNotifications({ userId, notifications, notificationList, unreadNotifications, }) {
    return __awaiter(this, void 0, void 0, function* () {
        yield setIndexedNotificationCache({
            userId,
            notifications,
            notificationList,
            unreadNotifications,
        });
    });
}
exports.setCachedNotifications = setCachedNotifications;
function getLoggedStatus() {
    const isLogged = Boolean(getCookie(COOKIE_NAME_LOGGED));
    const isSoftLogged = Boolean(getCookie(COOKIE_NAME_SOFT_LOGGED));
    if (currentEnv === "local") {
        return constants_1.LOGGED_STATUS.LOGGED;
    }
    if (isLogged) {
        return constants_1.LOGGED_STATUS.LOGGED;
    }
    if (isSoftLogged) {
        return constants_1.LOGGED_STATUS.SOFTLOGGED;
    }
    return constants_1.LOGGED_STATUS.PUBLIC;
}
exports.getLoggedStatus = getLoggedStatus;
function hasNotificationSession() {
    return getLoggedStatus() !== constants_1.LOGGED_STATUS.PUBLIC;
}
exports.hasNotificationSession = hasNotificationSession;
function setCachedNotificationHashlist({}) { }
exports.setCachedNotificationHashlist = setCachedNotificationHashlist;
//# sourceMappingURL=storage.js.map